import React from "react";
import Marketplacemenu from "./marketplacemenu/Marketplacemenu";
import Organizeclassmenu from "./organizeclasses/Organizeclasses";
import Organizefinancemenu from "./organizefinance/OrganizeFinance";
import Healthandfitnessmenu from "./health&fitnessmenu/Healthandfitness";
import Campuscommunitymenu from "./campus&community/Campusandcommunity";
import Jobsmenu from "./jobs/Jobs";
import Campusnewsalertsmenu from "./campusnewsandalerts/Campusnewsalerts";
import Askaicrowmenu from "./askai/Askaicrow";

const Menus = () => {
    return(
        <div className="px-2 py-3 hidden lg:flex gap-2 items-center justify-center flex-grow">
            <Marketplacemenu />
            <Organizeclassmenu />
            <Organizefinancemenu />
            <Healthandfitnessmenu />
            <Campuscommunitymenu />
            <Jobsmenu />
            <Campusnewsalertsmenu />
            <Askaicrowmenu />
        </div>
    )
}

export default Menus;